import {
    Box,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Grid,
  Stack,
  styled,
  Tooltip,
  Typography,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import VisibilityIcon from "@mui/icons-material/Visibility";


const ProductCard = styled(Card)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  transition: "all 0.3s ease",
  backgroundColor: "#ffffff",
  border: "1px solid #f0f0f0",
  boxShadow: "none",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: "0 6px 12px rgba(0,0,0,0.08)",
  },
  borderRadius: "16px",
  overflow: "hidden",
}));



export default function ProductsCards({ data, handleOpenDetails }) {
  return (
    <>
      {data.map((producto, key) => (
          <ProductCard elevation={1} key={key} sx={{ width: "100%" }}>
            <CardMedia
              component="img"
              height="140"
              image={
                producto?.img ||
                "https://www.pollosteo.com/wp-content/uploads/2021/08/Pollosteo-Logo.png"
              }
              alt={producto.name}
              sx={{
                objectFit: "cover",
                borderBottom: "1px solid #f0f0f0",
              }}
            />
            <CardContent
              sx={{
                p: 2,
                "&:last-child": { pb: 2 },
              }}
            >
              <Typography
                component="h2"
                sx={{
                  fontWeight: 500,
                  fontSize: 16,
                  mb: 1.5,
                  color: "#2c3e50",
                  lineHeight: 1.2,
                }}
              >
                {producto?.name}
              </Typography>

              <Stack spacing={1.5}>
                <Chip
                  label={`Cantidad: ${producto?.total_quantity}`}
                  size="small"
                  sx={{
                    fontWeight: 500,
                    fontSize: 13,
                    backgroundColor: "#f8f9fa",
                    color: "#495057",
                    borderRadius: "8px",
                    "& .MuiChip-label": {
                      px: 1.5,
                    },
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  {producto?.description && (
                    <Tooltip title="Ver detalles">
                      <Box
                        onClick={() => handleOpenDetails(producto)}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          cursor: "pointer",
                          borderRadius: 1,
                          px: 1,
                          py: 0.5,
                          "&:hover": {
                            backgroundColor: "#f8f9fa",
                            "& .MuiSvgIcon-root": {
                              color: "primary.main",
                            },
                            "& .details-text": {
                              color: "primary.main",
                            },
                          },
                        }}
                      >
                        <VisibilityIcon
                          sx={{
                            fontSize: 20,
                            color: "#6b7280",
                            transition: "color 0.2s",
                          }}
                        />
                        <Typography
                          className="details-text"
                          variant="body2"
                          sx={{
                            fontWeight: 500,
                            color: "#6b7280",
                            fontSize: 13,
                            transition: "color 0.2s",
                          }}
                        >
                          Ver detalles
                        </Typography>
                      </Box>
                    </Tooltip>
                  )}
                  {producto?.Order.priority ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "#fff9e6",
                        borderRadius: "8px",
                        px: 1,
                        py: 0.5,
                      }}
                    >
                      <StarIcon
                        sx={{
                          color: "#f9de4b",
                          fontSize: 18,
                          mr: 0.5,
                        }}
                      />
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 500,
                          color: "#6b5c00",
                          fontSize: 13,
                        }}
                      >
                        Prioritario
                      </Typography>
                    </Box>
                  ) : (
                    <Box />
                  )}
                </Box>
              </Stack>
            </CardContent>
          </ProductCard>
      ))}
    </>
  );
}
